import { ApplicationState } from 'ducks/application-state';

export const selectPermissionRole = (state: ApplicationState) => state.permission.role;
export const selectPermission = (state: ApplicationState) => state.permission.permission;
export const selectPermissionAccess = (state: ApplicationState) => state.permission.access;
export const selectPermissionLoading = (state: ApplicationState) => state.permission.loading;
